import Vue from 'vue'
import Router from 'vue-router'

import Home from '@/components/Home'
import Login from '@/components/Login'
import Dashboard from '@/components/Dashboard'
import Analysis from '@/components/Analysis'
import Account from '@/components/Account'
import AccountList from '@/components/AccountList'
import MapEdit from '@/components/MapEdit'
import ReportStatus from '@/components/ReportStatus'
import ReportCNC from '@/components/ReportCNC'
import ReportCNC_1 from '@/components/ReportCNC_1'
import SolarDashboard from '@/components/SolarDashboard'

const originalpush = Router.prototype.push

Router.prototype.push = function push(location) {
return originalpush.call(this, location).catch(err => err)
}

Vue.use(Router)
export default new Router({
    mode: "history",
    routes: [
        {
            path: '/',
            name: 'slash',
            component: Home
        },
        {
            path: '/Home',
            name: 'Home',
            component: Home
        },
        {
            path: '/Dashboard',
            name: 'Dashboard',
            component: Dashboard
        },
        {
            path: '/SolarDashboard',
            name: 'SolarDashboard',
            component: SolarDashboard
        },
        {
            path: '/Analysis',
            name: 'Analysis',
            component: Analysis
        },
        {
            path: '/Account',
            name: 'Account',
            component: Account
        },
        {
            path: '/AccountList',
            name: 'AccountList',
            component: AccountList
        },
        {
            path: '/login',
            name: 'login',
            component: Login
        },
        {
            path: '/MapEdit',
            name: 'MapEdit',
            component: MapEdit
        },
        {
            path: '/ReportStatus',
            name: 'ReportStatus',
            component: ReportStatus
        },
        {
            path: '/ReportCNC',
            name: 'ReportCNC',
            component: ReportCNC
        },
        {
            path: '/ReportCNC1',
            name: 'ReportCNC1',
            component: ReportCNC_1
        },
        {
            path: '/ReportQu',
            name: 'ReportQu',
            component: MapEdit
        },
        {
            path: '*',
            component: Error
        }

    ]
})
